import { customAttribute, autoinject } from 'aurelia-framework';
import { activationStrategy } from 'aurelia-router';

@autoinject
@customAttribute('on-enter')
export class OnEnter {
    element: Element;
    onEnter: any;
    action: any;

    constructor(element: Element) {
        this.element = element;
        this.onEnter=(ev:KeyboardEvent) => {
            if(ev.keyCode === 13) {
                this.action();
            }
        };
    }

    valueChanged(func) {
        this.action = func;
    }

    attached() {
        this.element.addEventListener("keyup", this.onEnter);
    }

    detached() {
        this.element.removeEventListener("keyup", this.onEnter);
    }
}